export default {
      id: "notifications-usage",
      viewBox: "0 0 20 20",
      url: "assets/" + "sprite.svg#notifications-usage",
      toString: function () {
        return this.url;
      }
    }